import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import PracticeAreas from "@/pages/PracticeAreas";
import PracticeAreaDetail from "@/pages/PracticeAreaDetail";
import Bio from "@/pages/Bio";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#102845",
              color: "#FAF7F2",
              border: "1px solid rgba(192, 151, 78, 0.3)",
              borderRadius: "2px",
              fontFamily: "'Inter', sans-serif",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/practice-areas" element={<PracticeAreas />} />
            <Route path="/practice-areas/:slug" element={<PracticeAreaDetail />} />
            <Route path="/richard-bufkin" element={<Bio />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
